import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateToLocale'
})
export class DateToLocalePipe implements PipeTransform {

  transform(dateCreated: Date): string {

    if (!dateCreated) {
      return '';
    }

    return new Date(dateCreated).toLocaleDateString();
  }

}
